import { render, staticRenderFns } from "./signals.vue?vue&type=template&id=45c327f2&"
import script from "./signals.vue?vue&type=script&lang=js&"
export * from "./signals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports